import React, { useEffect, useState } from 'react'
import { Container, Form, Table, Tabs, Tab } from 'react-bootstrap'
import { FAQ_COLLECTION } from '../../firebase'
import { useHistory } from 'react-router'
import { Link } from 'react-router-dom'
import moment from 'moment'

const PreviewFaq = () => {

    const history = useHistory()

    const [items, setItems] = useState([])

    const [search, setSearch] = useState('')

    const filteredItems = items.filter((item) => {

        let canReturnItem = false;

        const searchLowerCase = search.toLowerCase()

        if (item?.title_en && item.title_en.toLowerCase().includes(searchLowerCase)) {
            canReturnItem = true
        }
        if (item?.title_sr && item.title_sr.toLowerCase().includes(searchLowerCase)) {
            canReturnItem = true
        }

        return canReturnItem
    })

    useEffect(() => {

        const getItems = async () => {
            const snapshot = await FAQ_COLLECTION.get()
            const items = []
            snapshot.forEach(doc => {
                items.push(doc.data())
            })
            setItems(items)
        }

        getItems()

    }, [])

    return (
        <>
            <Container>
                <Tabs defaultActiveKey="preview-faq" className="mb-3" transition={false}>
                    <Tab eventKey="preview-faq" title="Pregled faq">
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>Pretraga</Form.Label>
                                <Form.Control type="search" placeholder="Unesite pojam za pretragu..." onChange={(e) => setSearch(e.target.value)} />
                                <Form.Text className="text-muted">
                                    Pretražite prema polju Naslov (EN) i Naslov (SR).
                                </Form.Text>
                            </Form.Group>
                        </Form>
                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                    <th>Uredi / obriši</th>
                                    <th>ID</th>
                                    <th>Datum</th>
                                    <th>Opis (EN)</th>
                                    <th>Opis (SR)</th>
                                    <th>Naslov (EN)</th>
                                    <th>Naslov (SR)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredItems.map((item) => (
                                    <tr key={item._id}>
                                        <td>
                                            <div>
                                                <Link to={`/edit-faq/${item._id}`}>
                                                    Uredi
                                                </Link>
                                                <br />
                                                <Link to={`/delete-faq/${item._id}`}>
                                                    Obriši
                                                </Link>
                                                <br />
                                                <a href={`https://soniteka.com/faq`} target="_blank" rel="noopener noreferrer">
                                                    Pregled
                                                </a>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item._id}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.date ? moment(item.date.toDate()).format('DD/MM/YYYY') : '-'}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.description_en}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.description_sr}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.title_en}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.title_sr}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Tab>
                    <Tab eventKey="add-faq" title={<div onClick={() => history.push('/add-faq')}>Dodaj</div>} />
                    <Tab eventKey="edit-faq" title='Uredi' disabled />
                    <Tab eventKey="delete-faq" title='Obriši' disabled />
                </Tabs>
            </Container>
        </>
    )
}

export default PreviewFaq
